import jump from 'jump.js';

const $trigger = document.querySelector('.js-md-Return__trigger');

if($trigger) {
  $trigger.onclick = function() {
    jump('body', {
      duration: 500
    });
  };
}

const $scrollTrigger = document.querySelector('.js-md-Inquiry');

if($scrollTrigger) {
  $scrollTrigger.onclick = function() {
    jump('#inquiry', {
      duration: 500,
      offset: -100
    });
  };

}

const $support = document.querySelector('.js-support');

if($support) {
  $support.onclick = function() {
    jump('#support', {
      duration: 500,
      offset: -100
    });
  };

}

